import { render, staticRenderFns } from "./videodetail.vue?vue&type=template&id=58d69cd6&scoped=true&"
import script from "./videodetail.vue?vue&type=script&lang=js&"
export * from "./videodetail.vue?vue&type=script&lang=js&"
import style0 from "./videodetail.vue?vue&type=style&index=0&id=58d69cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d69cd6",
  null
  
)

export default component.exports